import { styled, TooltipProps, tooltipClasses, Tooltip } from "@mui/material";
import Zoom from "@mui/material/Zoom";

const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    placement="top-start"
    slots={{
      transition: Zoom,
    }}
    {...props}
    arrow
    classes={{ popper: className }}
    slotProps={{
      popper: {
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, 14],
            },
          },
        ],
      },
    }}
  />
))(() => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "rgba(30, 27, 57, 1)",
    transform: "translateX(12px) !important",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "rgba(30, 27, 57, 1)",
    borderRadius: 8,
    paddingTop: 6,
    paddingBottom: 6,
    fontSize: 12,
    lineHeight: 1.3,
  },
}));

export default CustomTooltip;
